const initialEmployeeDesignation = {
    employeedesignations: [],
    filterempbydesigs: [],
};

const EmployeeDesignationReducer = (empdesign = initialEmployeeDesignation, action) => {
    switch (action.type) {
        
        case 'GET_EMPLOYEE_DESIGNATION':
        return {
            ...empdesign, employeedesignations: action.payload.data
        };
        case 'GET_EMPLOYEE_BY_DESIG':
        return {
            ...empdesign, filterempbydesigs: action.payload.data
        };
        
        default:
            return empdesign;
    }
}
export default EmployeeDesignationReducer;